import React from "react";
import { ListItem, ListItemText } from "@material-ui/core";
import { Link } from "react-router-dom";

const HeaderLinks = (props) => {
  const { link, label } = props;
  return (
    <ListItem button component={link && Link} to={link}>
      <ListItemText primary={label} />
    </ListItem>
  );
};

export default React.memo(HeaderLinks);
